module.exports = __webpack_public_path__ + "img/card_parent_account.4eaf8386.svg";